define('modules/editor/models/property_groups/form_radio_format',['require','exports','module','./base','lib/util'],function(require, exports, module) {
  "use strict";
  var BasePropertyGroup = require("./base"),
      util = require("lib/util");

  module.exports = BasePropertyGroup.extend({
    name: "form:radioFormat",
    properties: ["color", "fontFamily", "fontWeight", "fontSize"],
    validators: {
      "fontSize": function(attrs){
        var value = parseInt(attrs.fontSize);
        return this.isInteger(attrs.fontSize) && this.isNumber(value) && this.isInRange(value, 10, 60);
      }
    },
    generateStyles: function($el, id){
      return [{
        selector: "#" + id +  " label.radio-inline, #" + id + " label.checkbox-inline",
        rules: {
          "font-family": this.get("fontFamily"),
          "font-weight": this.get("fontWeight"),
          "font-size": this.get("fontSize") + "px",
          "color": this.get("color")
        }
      }];
    },
    //override to do nothing
    // applyStyles: function($el){
    //   var controls = $el.find("label.radio-inline, label.checkbox-inline");
    //   _.each(this.properties, function(name){
    //     if(name === "fontSize"){
    //       controls.css(name, this.get(name)+"px");
    //     }
    //     else {
    //       controls.css(name, this.get(name));
    //     }
    //   },this);
    // }
  });
});

